import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetUsersTemplatesQuery,
  GetUsersTemplatesQueryVariables,
} from "./GetUsersTemplates.generated";

export const GET_USERS_TEMPLATES: TypedDocumentNode<
  GetUsersTemplatesQuery,
  GetUsersTemplatesQueryVariables
> = gql`
  query GetUsersTemplates {
    user {
      uuid
      templates {
        uuid
        name
        description
        isPreset
        colorScheme
      }
    }
  }
`;
